import { API_BASE_URL } from 'containers/App/constants';
import { useEffect } from 'react';

const GpuInfo = () => {
  useEffect(() => {
    const canvas = document.createElement('canvas');
    let gl;
    let debugInfo;
    let vendor;
    let renderer;

    try {
      gl =
        canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    } catch (e) {
      console.error(
        'Unable to initialize WebGL. Your browser may not support it.',
        e,
      );
    }

    if (gl && gl instanceof WebGLRenderingContext) {
      debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
      if (debugInfo) {
        vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
        renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
        // Submit the information to the API
        submitGpuInfo({ vendor, renderer });
      }
    }
  }, []);

  const submitGpuInfo = async (gpuData: {
    vendor: string;
    renderer: string;
  }) => {
    try {
      const response = await fetch(API_BASE_URL + '/stats/gpu', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(gpuData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      // Handle the response here
      console.log('GPU data submitted successfully');
    } catch (error) {
      console.error('Failed to submit GPU data', error);
    }
  };

  return null;
};

export default GpuInfo;
